<div class="expander">
    <div data-int-expander="header" class="expander__header" (click)="toggle()">
        <ng-content select="header"></ng-content>
    </div>
    <div data-int-expander="content" [@heightSmooth]="isOpen ? 'open': 'close'">
      <ng-content select="content"></ng-content>
    </div>
</div>
